import { jsx as m } from "react/jsx-runtime";
import f from "clsx";
import { forwardRef as a } from "react";
import n from "./Popover.module.css.js";
const s = a(({ children: t, className: o, ...r }, e) => /* @__PURE__ */ m("div", { ref: e, className: f(n.content, o), ...r, children: t }));
s.displayName = "DefaultContent";
export {
  s as DefaultContent
};
//# sourceMappingURL=DefaultContent.js.map
